import { Injectable } from '@angular/core';

declare var analytics: any;

@Injectable({
    providedIn: 'root'
})
export class SegmentService {

    segmentInit = false;

    constructor() {
    }
    init(id, email, name, accountId, accountName, roles, sectionNames) {
        if (this.segmentInit) return;

        this.segmentInit = true;
        analytics.identify(email, {
            id: id,
            email: email,
            name: name,
            accountId: accountId,
            accountName: accountName,
            roles: roles,
            sectionNames: sectionNames
        });
    }
    track(trackType, trackData = {}) {
        analytics.track(trackType, trackData);
    }
}